import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import axios from "axios";
import {
  Row,
  Col,
  Card,
  Button,
  Space,
  message,
  Empty,
  Spin,
  Typography,
  Divider,
  Table,
  Modal,
  Input,
  InputNumber,
  Layout,
  Form,
} from "antd";
import {
  ACTION,
  CANCEL_REQUEST,
  DATE_TIME_FORMAT,
  FILE_TYPE,
} from "constants/index";
import emptyImg from "../../assets/img/empty.svg";
import AuthorizedFunction from "config/AuthorizedFunction";
import GeneralHelper from "helper/general.helper";
import NoteService from "services/note.service";
const { Title } = Typography;

const initialValues = {
  amount: null,
};

const BidderModal = ({ onClose, open = false, data }) => {
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    {
      title: "Name",
      dataIndex: "user",
      render: (data) => <>{data.username}</>,
      sorter: (a, b) =>
        a.user.username.toString().localeCompare(b.user.username.toString()),
    },
    {
      title: "Bid Price",
      dataIndex: "bid_price",
      render: (data) => <>{`$${data}`}</>,
      sorter: (a, b) => a.bid_price - b.bid_price,
    },
    {
      title: "Bid Time",
      dataIndex: "created_date",
      render: (data) => <>{moment(data).format(DATE_TIME_FORMAT.DATETIME)}</>,
      sorter: (a, b) => a.created_date - b.created_date,
    },
  ];

  useEffect(() => {
    if (data) {
      fetchData();
    }
  }, [open, data]);

  const handleCancel = () => {
    onClose(false);
  };

  const fetchData = () => {
    setIsLoading(true);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    NoteService.getListItemBids({ id: data.id }, source).then(
      (request) => {
        setTableData(request.items);
        setIsLoading(false);
      },
      (error) => {
        if (error && error.response.data && error.response.data.errors) {
          message.error(error.response.data.errors.join(". "), 5);
        } else if (error && error.message !== CANCEL_REQUEST) {
          message.error("API got error, please contact us.", 5);
        }
        console.log(error);
        setIsLoading(false);
        return Promise.reject();
      }
    );
  };

  return (
    data && (
      <Modal
        open={open}
        title={`Bidder of ${data.name}`}
        onCancel={handleCancel}
        width={800}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
        ]}
      >
        {!isLoading ? (
          <Space size={16} direction="vertical" style={{ width: "100%" }}>
            <Table
              columns={columns}
              dataSource={tableData}
              pagination={{ pageSize: 10 }}
            />
          </Space>
        ) : (
          <Empty
            image={emptyImg}
            imageStyle={{
              height: 60,
            }}
            description={<span>Loading..</span>}
          >
            <Spin />
          </Empty>
        )}
      </Modal>
    )
  );
};
export default BidderModal;
